import { Col } from '@amzn/stencil-react-components/layout';
import { token } from '@amzn/stencil-design-tokens/js/web/utils';

/** The 1px hairline rule, resolved through the Stencil token helper (not a raw
 *  `var(--st-dt-...)` string, which doesn't resolve in every render context and
 *  left the line invisible). Module-level for emotion reference stability. */
const DIVIDER_STYLE = {
  width: '100%',
  borderBottom: `${token('dimensions.border.width.100')} solid ${token('color.border.primary')}`,
} as const;

/**
 * Horizontal divider line using Stencil's border tokens. Full-width so it never
 * collapses to zero cross-size. Use between list items, card sections, or above
 * a footer actions row.
 */
export function Divider(): JSX.Element {
  return <Col css={DIVIDER_STYLE} />;
}
